module.exports = __webpack_public_path__ + "static/media/hands.948fac8c.svg";